import axios from 'axios';

const baseUrl = process.env.VUE_APP_FOLDER_CARDS_API;

export default {
  getVideosIds(type, age) {
    const headers = {
      'accept-language': 'en-AE,en;q=0.9',
    };

    return axios.get(baseUrl + `/getLiveVideos?contentType=${type}&minAge=${age.minAge}&maxAge=${age.maxAge}`, { headers })
      .then((response) => {
        const itemsList = response.data.videos.map((video) => {
          return {identifier: video.id};
        });

        return itemsList;
      }).catch((error) => {
        return error;
      });
  }
};